<div class="card-historiques  bg-white p-4" [ngClass]="{'cover': !allowed_to_update}" >
    <div class="card-doc-title ml-3 row">
        <fa-icon class="mr-2 fa-lg" [icon]="fa['faHistory']"></fa-icon>
        Historique de communications
    </div>
    <mat-form-field class="w-100 p-3">
        <input matInput (keyup)="applyFilter($event)" placeholder="Recherche..." #input>
    </mat-form-field>
    <div class="mat-elevation-z8">
        <table mat-table class="w-100" [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
                <td mat-cell *matCellDef="let row"> {{row.date}} </td>
            </ng-container>
            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Utilisateur </th>
                <td mat-cell *matCellDef="let row"> {{row.utilisateur}} </td>
            </ng-container>
            <ng-container matColumnDef="prospect">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Données du prospect </th>
                <td mat-cell *matCellDef="let row">
                    <p *ngIf="row.type==='sms'">{{row.donnees_prospect.tel}}</p>
                    <p *ngIf="row.type !=='sms' && row.type!=='sms' && row.type!=='mail'">{{row.donnees_prospect.mail}}</p>
                </td>
            </ng-container>
            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Détails </th>
                <td mat-cell *matCellDef="let row"> {{row.details}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let row">
                    <p *ngIf="row.type==='post'">
                        <fa-icon class="iconGris" [icon]="fa['faEnvelopeOpenText']"></fa-icon>
                        {{row.type}}
                    </p>
                    <p *ngIf="row.type==='mail'">
                        <fa-icon class="iconGris" [icon]="fa['faEnvelope']"></fa-icon>
                        {{row.type}}
                    </p>
                    <p *ngIf="row.type==='sms'">
                        <fa-icon class="iconGris" [icon]="fa['faSms']"></fa-icon>
                        {{row.type}}
                    </p>
                    <p *ngIf="row.type==='courrier'">
                        <fa-icon class="iconGris" [icon]="fa['faPaperPlane']"></fa-icon>
                        {{row.type}}
                    </p>
                    <p *ngIf="row.type ==='Visioconférence' && row.type!=='sms' && row.type!=='mail'">
                        <fa-icon class="iconGris" [icon]="fa['faVideo']"></fa-icon>
                        {{row.type}}
                    </p>
                </td>
            </ng-container>
            <ng-container matColumnDef="statut">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.statut==='S'"><img class="status-comm-width" src="assets/icons/check-circle.svg"></span>
                    <span *ngIf="row.statut==='E'"><img class="status-comm-width" src="assets/icons/times-icon.svg"></span>
                    <span *ngIf="row.statut==='P'"><fa-icon class="fa-lg " [icon]="fa['faClock']"></fa-icon></span>
                </td>
            </ng-container>
            <ng-container matColumnDef="fichier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fichier </th>
                <td mat-cell *matCellDef="let row">
                    <a *ngIf="row?.fichier" class="btn-dt-link iconBleu" target="_blank" href="{{row.fichier}}">
                        <fa-icon [icon]="fa['faPaperclip']"></fa-icon>

                    </a>
                </td>
            </ng-container>
            <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Lien </th>
                <td mat-cell *matCellDef="let row">
                    <a *ngIf="row?.lien" class="btn-dt-link iconBleu" target="_blank" href="{{row.lien}}">
                        <fa-icon [icon]="fa['faEye']"></fa-icon>
                    </a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7"> <div class="col-12 mt-2 d-flex justify-content-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="36" viewBox="0 0 31 36" fill="none">
                        <g clip-path="url(#clip0_1805_13925)">
                          <path d="M15.4954 0C14.2758 0 13.2905 0.996855 13.2905 2.23073V3.56916C8.2606 4.60087 4.47095 9.10415 4.47095 14.4997V15.8103C4.47095 19.0866 3.27894 22.2515 1.12917 24.7053L0.619293 25.2839C0.0405103 25.9392 -0.0972952 26.8802 0.254109 27.6819C0.605512 28.4836 1.39789 28.9994 2.26607 28.9994H28.7247C29.5929 28.9994 30.3784 28.4836 30.7367 27.6819C31.095 26.8802 30.9503 25.9392 30.3715 25.2839L29.8616 24.7053C27.7118 22.2515 26.5198 19.0936 26.5198 15.8103V14.4997C26.5198 9.10415 22.7302 4.60087 17.7003 3.56916V2.23073C17.7003 0.996855 16.715 0 15.4954 0ZM18.6167 34.388C19.4435 33.5515 19.9052 32.4152 19.9052 31.2302H15.4954H11.0856C11.0856 32.4152 11.5473 33.5515 12.3741 34.388C13.2009 35.2245 14.324 35.6916 15.4954 35.6916C16.6667 35.6916 17.7898 35.2245 18.6167 34.388Z" fill="#959494"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_1805_13925">
                            <rect width="30.8684" height="35.6916" fill="white" transform="translate(0.0625)"/>
                          </clipPath>
                        </defs>
                      </svg>
                  </div>
                  <div class="col-12  d-flex justify-content-center">
                    <p class="noData">Pas de données disponibles</p>
                  </div> </td>
            </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>